var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrioritySupportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    rx: 6,
    fill: "#3B58FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9C12.986 9 8.5 13.486 8.5 19V23.143C8.5 24.167 9.397 25 10.5 25H11.5C11.7652 25 12.0196 24.8946 12.2071 24.7071C12.3946 24.5196 12.5 24.2652 12.5 24V18.857C12.5 18.5918 12.3946 18.3374 12.2071 18.1499C12.0196 17.9624 11.7652 17.857 11.5 17.857H10.592C11.148 13.987 14.478 11 18.5 11C22.522 11 25.852 13.987 26.408 17.857H25.5C25.2348 17.857 24.9804 17.9624 24.7929 18.1499C24.6054 18.3374 24.5 18.5918 24.5 18.857V25C24.5 26.103 23.603 27 22.5 27H20.5V26H16.5V29H22.5C24.706 29 26.5 27.206 26.5 25C27.603 25 28.5 24.167 28.5 23.143V19C28.5 13.486 24.014 9 18.5 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioritySupportIcon);
export default __webpack_public_path__ + "static/media/priority-support-icon.aba909393aec7c7ee4810b076f3ef9da.svg";
export { ForwardRef as ReactComponent };